import { twoData } from "./landingPageConstant";
import { Link } from "react-router-dom";

export default function Two() {
  const content = (
    <section className="w-[90%]    mx-auto  lg:my-[4rem]   mb-[3rem]">
      <ul className=" min-h-full  ">
        {twoData.map((data) => (
          <li
            key={data.id}
            className={`flex flex-col justify-end  items-center  ${
              data.id === 1
                ? "lg:flex-row   justify-center  items-start"
                : "lg:flex-row-reverse  justify-center  items-end"
            }  gap-[1.5rem]  my-[2rem]`}
          >
            <img
              src={data.imgUrl}
              alt="data"
              className="mt-[3rem]  h-[18rem]  w-[20rem] md:w-[85%]  md:h-[25rem]  lg:h-[20rem] lg:w-[25rem]   xl:h-[35rem] xl:w-[55%]  rounded-tr-[2rem]"
            />
            <div className=" md:w-[80%]    flex  flex-col gap-[1rem] lg:w-[30rem] ">
              <div className="flex flex-col gap-[1rem]  justify-start items-start  ">
                <h4 className="font-bold  md:text-[1.5rem]  xl:text-[2rem]  tracking-wide  ">
                  {data.title}
                </h4>
                <p className="text-gray-500">{data.subTitle}</p>
                <hr className="w-[20%] p-[0.01rem] bg-black " />
                <p className="font-thin   md:w-[90%]">{data.description}</p>
              </div>
              <div className="bg-[#EDF7FD]  flex  flex-col gap-[0.5rem] p-[0.5rem] lg:min-w-full">
                <h6 className="custom-blue-text  font-medium">
                  Services Available
                </h6>
                <hr className="w-[20%] p-[0.01rem] bg-yellow-600 " />
                <ul className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-[0.5rem]">
                  {data.subData.map((sd) => (
                    <li key={sd.id} className="">
                      <div className="  custom-blue-text   flex justify-start items-center gap-[0.5rem]">
                        {sd.icon} {sd.title}
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
              <Link
                className=" w-[100%]  md:w-[70%]    bg-red-700  text-white  text-center  py-[0.5rem] font-medium   px-[0.2rem]"
                to={data.serviceLink}
              >
                {data.serviceLinkTitle}
              </Link>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );

  return content;
}
